// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.work-flow-block__container {
  background-color: var(--secondary-color);
}
.work-flow-block__container h1 {
  color: var(--web-primary-color);
}

.work-flow-block__content {
  display: flex;
  flex-direction: column;
}
.work-flow-block__content .arrow-block:last-child {
  display: none;
}

.work-flow-block__text {
  color: var(--secondary-text-color);
}

.arrow-block {
  display: flex;
  justify-content: center;
}

@media only screen and (min-device-width: 320px) {
  .work-flow-block__container > h1 {
    margin-bottom: 12px;
  }
  .work-flow-block__content {
    gap: 16px;
  }
  .work-flow-block__text {
    margin-bottom: 20px;
  }
  .work-flow-block__view {
    gap: 32px;
    flex-direction: column;
    padding: 16px;
  }
}
@media only screen and (min-device-width: 768px) {
  .work-flow-block__container > h1 {
    margin-bottom: 24px;
  }
  .work-flow-block__content {
    gap: 32px;
  }
  .work-flow-block__text {
    margin-bottom: 44px;
  }
  .work-flow-block__view {
    flex-direction: row;
    gap: 32px;
    padding: 24px 36px;
  }
}
@media only screen and (min-device-width: 992px) {
  .work-flow-block__container > h1 {
    margin-bottom: 32px;
  }
  .work-flow-block__content {
    gap: 32px;
  }
  .work-flow-block__text {
    margin-bottom: 52px;
  }
  .work-flow-block__view {
    flex-direction: row;
    gap: 52px;
    padding: 28px;
  }
}
@media only screen and (min-device-width: 1366px) {
  .work-flow-block__container > h1 {
    margin-bottom: 36px;
  }
  .work-flow-block__content {
    gap: 40px;
  }
  .work-flow-block__text {
    margin-bottom: 52px;
  }
  .work-flow-block__view {
    flex-direction: row;
    gap: 52px;
    padding: 36px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/LandingPage/components/WorkFlowBlock/workFlowBlock.scss"],"names":[],"mappings":"AAAA;EACE,wCAAA;AACF;AACE;EACE,+BAAA;AACJ;;AAGA;EACE,aAAA;EACA,sBAAA;AAAF;AAEE;EACE,aAAA;AAAJ;;AAIA;EACE,kCAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;AADF;;AAKA;EACE;IACE,mBAAA;EAFF;EAIA;IACE,SAAA;EAFF;EAIA;IACE,mBAAA;EAFF;EAIA;IACE,SAAA;IACA,sBAAA;IACA,aAAA;EAFF;AACF;AAKA;EACE;IACE,mBAAA;EAHF;EAKA;IACE,SAAA;EAHF;EAKA;IACE,mBAAA;EAHF;EAKA;IACE,mBAAA;IACA,SAAA;IACA,kBAAA;EAHF;AACF;AAMA;EACE;IACE,mBAAA;EAJF;EAMA;IACE,SAAA;EAJF;EAMA;IACE,mBAAA;EAJF;EAMA;IACE,mBAAA;IACA,SAAA;IACA,aAAA;EAJF;AACF;AAOA;EACE;IACE,mBAAA;EALF;EAOA;IACE,SAAA;EALF;EAOA;IACE,mBAAA;EALF;EAOA;IACE,mBAAA;IACA,SAAA;IACA,aAAA;EALF;AACF","sourcesContent":[".work-flow-block__container {\n  background-color: var(--secondary-color);\n\n  h1 {\n    color: var(--web-primary-color);\n  }\n}\n\n.work-flow-block__content {\n  display: flex;\n  flex-direction: column;\n\n  .arrow-block:last-child {\n    display: none;\n  }\n}\n\n.work-flow-block__text {\n  color: var(--secondary-text-color);\n}\n\n.arrow-block {\n  display: flex;\n  justify-content: center;\n\n}\n\n@media only screen and (min-device-width: 320px) {\n  .work-flow-block__container > h1 {\n    margin-bottom: 12px;\n  }\n  .work-flow-block__content {\n    gap: 16px;\n  }\n  .work-flow-block__text {\n    margin-bottom: 20px;\n  }\n  .work-flow-block__view {\n    gap: 32px;\n    flex-direction: column;\n    padding: 16px;\n  }\n}\n\n@media only screen and (min-device-width: 768px) {\n  .work-flow-block__container > h1 {\n    margin-bottom: 24px;\n  }\n  .work-flow-block__content {\n    gap: 32px;\n  }\n  .work-flow-block__text {\n    margin-bottom: 44px;\n  }\n  .work-flow-block__view {\n    flex-direction: row;\n    gap: 32px;\n    padding: 24px 36px;\n  }\n}\n\n@media only screen and (min-device-width: 992px) {\n  .work-flow-block__container > h1 {\n    margin-bottom: 32px;\n  }\n  .work-flow-block__content {\n    gap: 32px;\n  }\n  .work-flow-block__text {\n    margin-bottom: 52px;\n  }\n  .work-flow-block__view {\n    flex-direction: row;\n    gap: 52px;\n    padding: 28px;\n  }\n}\n\n@media only screen and (min-device-width: 1366px) {\n  .work-flow-block__container > h1 {\n    margin-bottom: 36px;\n  }\n  .work-flow-block__content {\n    gap: 40px;\n  }\n  .work-flow-block__text {\n    margin-bottom: 52px;\n  }\n  .work-flow-block__view {\n    flex-direction: row;\n    gap: 52px;\n    padding: 36px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
